import {
  createSpinner,
  scrollToEvent, validateCheckbox, validateEmail, validateField,
} from './helpers';
import { contest } from './initializeStats';
import { uploadPhoto } from './uploadPhoto';

export const validateAndSubmitForm = () => {
  const forms = document.querySelectorAll('form');
  if (forms.length) {
    forms.forEach((form) => {
      const data = {};
      
      const fieldsNotMail = form.querySelectorAll(
        '.form-field:not([id="email"]):not([id="uploadUrl"])',
        //'.form-field:not([id="email"])',
      );
      const mailToValidate = form.querySelector(
        '.form-field[id="email"]',
      );
      const checkboxes = form.querySelectorAll('.form-checkbox--required input');

      const uploadInput = form.querySelector('#upload');
      if (uploadInput) {
        uploadPhoto(form, '#upload', form.getAttribute('data-upload-size'), '#uploadUrl');
      }

      fieldsNotMail.forEach((el) => {
        const dataId = el.getAttribute('data-id');
        if (dataId) {
          data[dataId] = el.value;
        }
        el.addEventListener('input', function () {
          if (el.closest('fieldset').classList.contains('has-error')) {
            validateField(this, 2);
          }
        });
        
          console.log(el.getAttribute('id'));
          el.addEventListener('change', function () {
            validateField(this, 2);
          });
        
      });
      if (mailToValidate) {
        mailToValidate.addEventListener('input', function () {
          if (mailToValidate.closest('fieldset').classList.contains('has-error')) {
            validateEmail(this);
          }
        });
        mailToValidate.addEventListener('change', function () {
          validateEmail(this);
        });
      }

      checkboxes.forEach((el) => {
        el.addEventListener('change', function () {
          validateCheckbox(this);
        });
      });

      const submitBtn = form.querySelector('.btn-main');

      

      // oddanie glosu - wysylanie danych z formularza
      submitBtn.addEventListener('click', (e) => {
        e.preventDefault();
        let formIsValid = true;

        // walidacja formularza

        fieldsNotMail.forEach((el) => {
          if (!validateField(el, 2)) {
            formIsValid = false;
          } else {
            data[el.getAttribute('data-id')] = el.value;
            console.log(data[el.getAttribute('id')]);
          }
        });
        if (!validateEmail(mailToValidate)) {
          formIsValid = false;
        } else {
          data[mailToValidate.getAttribute('data-id')] = mailToValidate.value;
        }

        checkboxes.forEach((el) => {
          if (!validateCheckbox(el)) {
            formIsValid = false;
          } else {
            data[el.getAttribute('data-id')] = el
              .closest('fieldset')
              .querySelector('label').innerText;
          }
        });
        
        const uploadUrlField = form.querySelector('#uploadUrl');
        if (uploadUrlField) {
          data[uploadUrlField.getAttribute('data-id')] = uploadUrlField.value;
        }
        
        if (formIsValid) {
          createSpinner(form, true);

          /* test */
          // console.log(data);
          // setTimeout(() => {
          //   const vC = form.closest('.section--light');
          //   const response = `<div class="wrapper">
          //         <h3 class="text__header">
          //                   Dziękujemy za oddanie głosu :)!
          //                 </h3>
          //       </div>`;
          //   vC.innerHTML = response;
          //   scrollToEvent(vC.getBoundingClientRect().top + window.scrollY - 90, () => {
          //     document.querySelector('.header').classList.remove('header--translated');
          //     contest.isScrollingController(false);
          //   });
          // }, 4000);
          /* koniec testu */

          /* FORMULARZ */
          const url = form.getAttribute('data-url');
          (async () => {
            try {
              const response = await (await fetch(url, {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
              })).text();
              // console.log(response);
              const vC = form.closest('.section--light');
              vC.classList.add('__jsResponse');
              vC.innerHTML = response;
              WP.push(() => {
                WP.pwp.customAction({
                  ga: {
                    event: 'site_interaction',
                    eventCategory: 'send_form',
                    eventAction: 'ontouchstart' in document.documentElement ? 'tap' : 'click',
                    eventLabel: window.location.href,
                  },
                });
              });
              scrollToEvent(vC.getBoundingClientRect().top + window.scrollY - 90, () => {
                document.querySelector('.header').classList.remove('header--translated');
                contest.isScrollingController(false);
              });
            } catch (err) {
              console.log('Error:', err);
            }
          })();

          /* KONIEC FORMULARZA */
        }
      });
    });
  }
};
if (document.getElementById('zip-code')!==null) { 
document.getElementById('zip-code').addEventListener('input', function () {
  let value = this.value.replace(/[^0-9]/g, '');
  if (value.length > 2) {
    value = `${value.substring(0, 2)}-${value.substring(2, 5)}`;
  }
  this.value = value;
});
}
if (document.getElementById('phone-number')!==null) {
  document.getElementById('phone-number').addEventListener('input', function () {
    let value = this.value.replace(/[^0-9]/g, '');
    if (value.length > 3 && value.length <= 6) {
      value = `${value.substring(0, 3)}-${value.substring(3)}`;
    } else if (value.length > 6) {
      value = `${value.substring(0, 3)}-${value.substring(3, 6)}-${value.substring(6, 9)}`;
    }
    this.value = value;
  });
}

if (document.getElementById('toggle-expand')!==null) {

document.getElementById('toggle-expand').addEventListener('click', function () {
  const content = document.getElementById('expandable-content');
  const isExpanded = this.getAttribute('aria-expanded') === 'true';

  this.setAttribute('aria-expanded', !isExpanded);
  content.classList.toggle('hidden');
});
}

const options = document.querySelectorAll('.selectable-option');
options.forEach((option) => {
  option.addEventListener('click', function () {
    options.forEach((opt) => opt.classList.remove('selected'));

    this.classList.add('selected');
  });
});

document.querySelectorAll('.selectable-option').forEach((option) => {
  option.addEventListener('click', (e) => {
    document.getElementById('expandable-option').value = e.target.getAttribute('data-id');
  });
});

document.querySelectorAll('.radio-group input[type="radio"]').forEach((radio) => {
  radio.addEventListener('change', (e) => {
    document.getElementById('radio-group-selected').value = e.target.getAttribute('data-id');
  });
});
